var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 16 16",
    id: "youtube",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.862 4.463c-.407-.702-.848-.831-1.747-.88-.898-.059-3.157-.083-5.113-.083-1.96 0-4.22.024-5.117.083-.897.05-1.339.178-1.75.88C.716 5.165.5 6.372.5 8.498v.008c0 2.117.216 3.333.635 4.026.41.701.852.829 1.75.888.897.05 3.156.08 5.117.08 1.956 0 4.215-.03 5.114-.08.899-.059 1.34-.187 1.747-.888.424-.694.638-1.91.638-4.026v-.008c-.001-2.126-.214-3.333-.639-4.035z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11V6l4 2.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.86521cb2f3f7cab6797c7504472cd0cd.svg";
export { ForwardRef as ReactComponent };